export const VALIDATION_RULES = [{ required: true, message: "Please enter value" }];
export const MAC_ADDRESS_VALIDATION_RULES = [
  {
    pattern: new RegExp(/^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/),
    message: "Please match the requested format. For example, B8:D6:1A:84:03:4C",
  },
];
